import React, { useState } from "react";
import "./AdditionalInfo.css";

import user1 from "../../../Assets/Users/user1.jpeg";
import user2 from "../../../Assets/Users/user2.jpeg";

import { FaStar } from "react-icons/fa";
import Rating from "@mui/material/Rating";
import axios from "axios";
import * as backendModule from "../../../modules/backendModule";
import Spinner from "../../Spinner";

const AdditionalInfo = (props) => {
  const [activeTab, setActiveTab] = useState("aiTab1");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const [data, setData] = React.useState([]);
  const [error, setError] = React.useState(null);
  const [spinner, setSpinner] = React.useState(true);

  const getData = () => {
    axios({
      method: "POST",
      url: `${backendModule.backendURL}/products/getProductByID`,
      data: {
        ID: props.productID
      },
      ...backendModule.axiosConfig,
    }).then(res => {
      if (res.data.status === "ok") {
        setData(res.data?.data);
        setError(null);
      } else {
        setError('Došlo je do serverske greške');
      }
    }).catch(() => {
      setError('Došlo je do serverske greške');
    }).finally(() => {
      setSpinner(false);
    });
  }

  React.useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className="productAdditionalInfo">
        {!error && !spinner ? <div className="productAdditonalInfoContainer">
          <div className="productAdditionalInfoTabs">
            <div className="aiTabs">
              <p
                onClick={() => handleTabClick("aiTab1")}
                className={activeTab === "aiTab1" ? "aiActive" : ""}
              >
                Opis
              </p>
              <p
                onClick={() => handleTabClick("aiTab2")}
                className={activeTab === "aiTab2" ? "aiActive" : ""}
              >
                Dostava i plaćanje
              </p>
              <p
                onClick={() => handleTabClick("aiTab3")}
                className={activeTab === "aiTab3" ? "aiActive" : ""}
              >
                Garancija i zamjena
              </p>
            </div>
          </div>
          <div className="productAdditionalInfoContent">
            {/* Tab1 */}

            {activeTab === "aiTab1" && (
              <div className="aiTabDescription">
                <div className="descriptionPara">
                  <h3>Saznaj više o ovom proizvodu</h3>
                  <p>
                    {data?.Description}
                  </p>
                </div>
              </div>
            )}

            {/* Tab2 */}

            {activeTab === "aiTab2" && (
              <div className="delivery-payment-info">
                <strong>
                  Brza dostava iznosi 12 KM.
                </strong>
                <p>Trošak dostave za narudžbu iznosi 12 KM.</p>
                <br />
                <strong>ROK DOSTAVE</strong>

                <p>Rok isporuke je najčešće 1-3 radna dana, u veće gradove može biti dostavljeno i za 24h.</p>
                <br />
                <strong>PLAĆANJE</strong>
                <p>- plaćanje po preuzimanju</p>
                <p>- Kartično plaćanje svim vrstama kartica (Visa, Maestro, Mastercard, AMEX...)</p>
              </div>
            )}

            {/* Tab3 */}

            {activeTab === "aiTab3" && (
              <div className="aiTabReview">
                <p>
                  Svi artikli su pokriveni Garancijom na orginalnost. Bezbrižna online kupovina od provjerenog trgovca sa preko 20 godina isksutva i preko 20.000 zadovoljnih kupaca.
                  <br />
                  Naočale možes zamijeniti ukoliko ti ne odgovaraju ili ti se ne sviđaju.
                </p>
              </div>
            )}
          </div>
        </div> : null}
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {spinner && <Spinner color="black" style={{ width: "64px", height: "50px", marginLeft: "auto", marginRight: "auto", display: "block" }} />}
      </div>
    </>
  );
};

export default AdditionalInfo;
